import _taggedTemplateLiteral from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        cursor: not-allowed;\n        border: 1px solid ", ";\n        color: ", ";\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: relative;\n\n  select,\n  .select {\n    width: 100%;\n    display: flex;\n    height: 3.5rem;\n    padding: 0 0.75rem;\n    font: inherit;\n    border: 1px solid\n      ", ";\n    border-radius: 0.5rem;\n    box-shadow: none;\n    background: ", ";\n    -webkit-appearance: none;\n    color: inherit;\n    cursor: pointer;\n    position: relative;\n    z-index: 1;\n\n    ", ";\n    padding-right: 2.25rem;\n\n    ", "\n\n    &:focus {\n      border-color: ", ";\n      box-shadow: 0px 0px 0px 1px ", ";\n      outline: 0;\n    }\n  }\n\n  .select-icon {\n    position: absolute;\n    z-index: 2;\n    width: 1.25rem;\n    left: 0.75rem;\n\n    svg {\n      width: 100%;\n      height: auto;\n    }\n  }\n\n  .select-arrow {\n    left: initial;\n    right: 0.75rem;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { KeyboardArrowDown } from '@styled-icons/material-outlined';
var StyledSelectContainer = styled.div(_templateObject(), function (props) {
  return props.status === 'default' ? props.theme.colors.inputBorder : props.theme.colors[props.status];
}, function (props) {
  return props.theme.colors.inputBackground;
}, function (props) {
  return props.icon && "padding-left: 2.25rem;";
}, function (props) {
  return props.disabled && css(_templateObject2(), props.theme.colors.border, props.theme.colors.disabledText);
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
});

function SelectContainer(_ref) {
  var icon = _ref.icon,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      children = _ref.children,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? 'default' : _ref$status,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return _jsxs(StyledSelectContainer, Object.assign({
    disabled: disabled,
    status: status,
    icon: Boolean(icon),
    className: "select-container ".concat(className)
  }, {
    children: [icon && _jsx("span", Object.assign({
      className: "select-icon"
    }, {
      children: icon
    }), void 0), children, _jsx("span", Object.assign({
      className: "select-icon select-arrow"
    }, {
      children: _jsx(KeyboardArrowDown, {}, void 0)
    }), void 0)]
  }), void 0);
}

export default SelectContainer;